import { useQuery } from '@tanstack/react-query';

import { Template } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { listSignatureTemplates } from '../../requests/listSignatureTemplates';

export const useSignatureTemplates = (
  envelopeId: string,
  params?: { search?: string },
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<Template[]> | undefined
  >({
    queryKey: [SIGNATURE_BASE_PATH, 'templates', 'search', envelopeId, params],
    queryFn: () => listSignatureTemplates(constructGet, envelopeId, params),
    enabled: !!envelopeId,
    ...options,
  });

  return { ...unwrapNonPaginatedResponseDataAs(data, 'templates'), ...rest };
};
